import React, { createContext, useContext, useState, ReactNode } from 'react';

export type Language = 'tr' | 'en';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const translations = {
  tr: {
    home: 'Ana Sayfa',
    translator: 'Çevirmen',
    projects: 'Projeler',
    settings: 'Ayarlar',
    welcome: 'Hoş Geldiniz!',
    description: 'Modern çeviri uygulaması',
    getStarted: 'Başla',
    learnMore: 'Daha Fazla Bilgi',
    fast: 'Hızlı',
    fastDesc: 'Modern React ve optimizasyon teknikleri ile yüksek performans',
    beautiful: 'Güzel',
    beautifulDesc: 'Modern ve responsive tasarım',
    flexible: 'Esnek',
    flexibleDesc: 'TypeScript desteği ile güvenli ve ölçeklenebilir kod'
  },
  en: {
    home: 'Home',
    translator: 'Translator',
    projects: 'Projects',
    settings: 'Settings',
    welcome: 'Welcome!',
    description: 'Modern translation application',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    fast: 'Fast',
    fastDesc: 'High performance with modern React and optimization techniques',
    beautiful: 'Beautiful',
    beautifulDesc: 'Modern and responsive design',
    flexible: 'Flexible',
    flexibleDesc: 'Safe and scalable code with TypeScript support'
  }
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('tr');

  const t = (key: string): string => {
    return translations[language][key as keyof typeof translations['tr']] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};




